<template>
  <div class="page-container">
    <div class="container">
      <div class="rules" @click="$refs.rulesRef.open()"></div>
      <div class="address" @click="$refs.mailRef.open()"></div>
      <img class="img" src="@/static/images/activityCenter/202404/03.png" />
      <div class="go-order-btn" @click="goOrderDetail"></div>
    </div>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>

    <!-- 邮寄信息 -->
    <mail-popup ref="mailRef"></mail-popup>
  </div>
</template>

<script>
import config from '@/api/common'; //公共变量
import activityRules from './components/rulePopup';
import mailPopup from './components/mailPopup03';

export default {
  components: {
    activityRules,
    mailPopup
  },

  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('jzy_user')),
      ruleText: '<h1 style=\"text-align:center;font-size: 22px;\">规则详情</h1><h2 style="margin-top: 10px;">一、活动时间：</h2><h1><p>2024年4月1日——2024年4月30日</p><p><br/></p></h1><h2>二、活动对象：</h2><h1><p>OK保已签约代理人</p><p><br/></p></h1><h2>三、新客礼遇</h2><h3>（一）活动内容</h3><h1><p>活动期间内，首次出单1件\"星之保少儿百万医疗险”即可获得保温杯/U型枕/充电宝三选一奖品一份，仅限前100位出单者，数量有限，先到先得。</p></h1><h3>（二）注意事项</h3><h1><p>奖品图片仅供参考，具体请以实物为准，奖品若提前兑现完，将会提前联系您，更换等价值其他奖品。</p><p><br/></p></h1><h2>四、绩优争霸&nbsp;(100名)</h2><h3>（一）活动内容</h3><h1><p>活动期间内出单星之保少儿百万医疗险，在活动结算后，件数和排名达到标准，获得对应奖励，具体标准如下：</p><table><tbody><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>出单件数及排名</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>奖励</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>奖励数量</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名第1名且件数≥68件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>SUPOR炒菜机器人</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>1</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前3名且件数≥58件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>ipad9&nbsp;256G/大疆智能无人机</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>2</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前6名且件数≥28件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>TINECO扫地机器人</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>3</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前14名且件数≥18件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>松下自动美式咖啡机</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>8</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前30名且件数≥8件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>JBL音响</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>16</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前60名且件数≥6件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>SUPOR电饭煲</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>30</p></td>\n    \n            \n    </tr><tr>\n            \n            <td colspan=\"1\" rowspan=\"1\"><p>件数排名前100名且件数≥3件</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>拜尔X3智能声波电动牙刷</p></td>\n    <td colspan=\"1\" rowspan=\"1\"><p>40</p></td>\n    \n            \n    </tr></tbody></table></h1><h3>（二）注意事项</h3><h1><p>1、奖品图片仅供参考，具体请以实物为准，奖品若提前兑现完，将会提前联系您，更换等价值其他奖品。</p><p>2、对应类别的累计件数排名奖励仅以达成的最高门槛对应的奖励进行发放，仅可获得一份奖励。</p><p><br/></p></h1><h2>五、活动规则</h2><h1><p>1、如遇退保，OK保将扣回此单所有推广费及对应活动奖励。</p><p>2、如发现同一代理人活动期间退保率超过10%，OK保有权追回所有奖励。</p><p>3、活动订单仅计算活动期间所出新单，不含追加、加保、续期订单。</p><p>4、投保时间和承保时间都需要在活动期间内，在活动结束次月20日24点前成功通过质检、且签收回执、保单过犹过访，满足以上所有条件方可计入活动业绩。</p><p>5、代理人奖励发放时，需满足平台业务品质要求。如不满足，平台有权不予发放奖励。OK保有权对业绩品质进行质检。</p><p>6、参加活动要求个人继续率&nbsp;≥90%，且个人新单退保率&lt;5%，达标与否，将以活动开始前定版数据&nbsp;(即2024.3.31日零点系统数据)&nbsp;为准。</p><p>7、代理人若在奖励发放前离职或停职，则奖励不予结算。</p><p><br/></p></h1><h2>六、活动奖励发放</h2><h1><p>1、活动奖励将会在活动结束后的次月20日之后进行发放。未回执回访，未完成质检单录，或产生退保的订单奖励不予结算。领取途径：进入APP活动页面，点击弹窗填写邮寄信息即可</p><p>2、退保的情况下，数据同步会有延迟，以活动结束后的最终核算（扣除退保件等）为主，来进行活动奖励发放。</p><p><br/></p></h1><h2>七、活动参与资格、获奖资格的取消</h2><h1><p>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</p><p>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</p><p>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</p><p>3、违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</p><p><br/></p></h1><h2>八、免责条款</h2><h1><p>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</p><p><br/></p><p>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</p></h1>'
    };
  },

  methods: {
    // 去出单
    goOrderDetail() {
      let url = '';
      if (config.env == '0' || config.env == '2') {
        url = `https://fqjdstore.wts9999.net/m/product/app/${this.userInfo.userId}/126001`;
      } else {
        url = `https://jdstore.fxyf99.com/m/product/app/${this.userInfo.userId}/126001`;
      }
      window.location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  .rules {
    position: absolute;
    right: 0;
    top: 250px;
    width: 66px;
    height: 80px;
  }
  .address {
    position: absolute;
    right: 0;
    top: 355px;
    width: 66px;
    height: 80px;
  }
  .img {
    width: 750px;
    display: block;
  }
  .go-order-btn {
    position: absolute;
    right: 0;
    bottom: 95px;
    width: 380px;
    height: 90px;
    left: 50%;
    margin-left: -190px;
    border-radius: 55px;
  }
}
</style>
